<template>
  <div class="strategy-modal">
    <div class="modal fade" data-bs-backdrop="static" id="strategyDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">

          <div class="modal-header">
            <div class="h5 modal-title text-light">
              <span v-if="elementType === 'strategy'"> {{ $t("views.strategy.edit.headingDeleteStrategy") }} </span>
              <span v-if="elementType === 'review'"> {{ $t("views.strategy.edit.headingDeleteReview") }} </span>
              <span v-if="elementType === 'measure'"> {{ $t("views.strategy.edit.headingDeleteMeasure") }} </span>
              <span v-if="elementType === 'relationship'"> {{ $t("views.strategy.edit.headingDeleteRelationship") }} </span>
              <span v-if="elementType === 'trial'"> {{ $t("views.strategy.edit.headingDeleteTrial") }} </span>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light">
            <div v-if="elementType === 'strategy'" class="text-center my-3">
              <p class="fw-bold">{{ this.selectedStrategy.name }}</p>
              <p> {{ $t("views.strategy.edit.confirmDeleteStrategy") }}</p>
              <p> {{ $t("views.strategy.edit.infoDelete") }}</p>
            </div>
            <div v-if="elementType === 'review'" class="text-center my-3">
              <p class="fw-bold"> {{ this.strategyModalElementName }}</p>
              <p> {{ $t("views.strategy.edit.confirmDeleteReview") }}</p>
            </div>
            <div v-if="elementType === 'measure'" class="text-center my-3">
              <p class="fw-bold"> {{ this.strategyModalElementName }}</p>
              <p> {{ $t("views.strategy.edit.confirmDeleteMeasure") }}</p>
            </div>
            <div v-if="elementType === 'relationship'" class="text-center my-3">
              <p class="fw-bold"> {{ this.strategyModalElementName }}</p>
              <p> {{ $t("views.strategy.edit.confirmDeleteRelationship") }}</p>
            </div>
            <div v-if="elementType === 'trial'" class="text-center my-3">
              <p class="fw-bold"> {{ this.strategyModalElementName }}</p>
              <p> {{ $t("views.strategy.edit.confirmDeleteTrial") }}</p>
            </div>
          </div>

          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StrategyDeleteModal',
  mounted () {
    const myModalDialog = document.getElementById('strategyDeleteModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      this.strategyModalElementName = this.$parent.strategyModalElementName
    })
  },
  data () {
    return {
      strategyModalElementName: ''
    }
  },
  computed: {
    selectedStrategy () {
      return this.$store.state.selectedStrategy
    },
    elementId () {
      return this.$parent.strategyModalElementId
    },
    elementType () {
      return this.$parent.strategyModalElementType
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        if (this.elementType === 'strategy' && !this.selectedStrategy.hasNodes) {
          await this.$store.dispatch('deleteStrategy', this.selectedStrategy.id)
        } else {
          await this.$store.dispatch('deleteStrategyElement', { strategyId: this.selectedStrategy.id, elementType: (this.elementType + 's'), elementId: this.elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }

      // Reload Data & Treeview
      if (this.elementType === 'review') {
        await this.$store.dispatch('getStrategies', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo })
      }
    }
  }
}
</script>
